<template>
  <div class="search">
    <div class="findInput">    
    <el-popover
      placement="bottom-start"
      width="324"
      trigger="manual"
      popper-class="search-popover"
      v-model="visible">
      <el-input
        slot="reference"
        class="search-input"
        placeholder="智能搜索"
        v-model="searchValue"
        @input="inputChange"
        @focus="inputChange"
        @blur="inputBlur"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <div v-if="result.length === 0" class="search-empty" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <img :src="$globalCdn + '/images/public/searchNoRes.png'" style="width: 110px; height: 75px;" />
        <span style="font-size: 12px; color: #999999;">没搜到匹配内容，换条件再搜吧~</span>
      </div>
      <div v-else class="search-list" :style="{'height':result.length * 35 + 'px'}">
        <el-scrollbar class="search-list__scroll">
          <div class="search-list-item" v-for="item in result" :key="item.path" @click="itemClick(item)">
            <div v-html="item.label"></div>
          </div>
        </el-scrollbar>
      </div>
    </el-popover></div>

  </div>
</template>

<script>
export default{
  data(){
    return {
      visible:false,
      searchValue:null,
      result:[]
    }
  },
  computed:{
    // 获取菜单
    userRoute() {
      return this.$store.state.route.filter(route=>route.path != '/bi' && route.path != '/bi_preview')
    },
    // 用户管理>人群管理>京东人群
    getRouteList(){
      function getPageTabs(data) {
        let pageTabs = [];
        function traverse(nodes, parentName) {
          nodes.forEach(node => {
            const tittle = parentName ? `${parentName} > ${node.tittle}` : node.tittle;
            if (node.children && node.children.length > 0) {
              traverse(node.children, tittle);
            }else{
              pageTabs.push({
                path:node.jumpUrl,
                label:tittle,
                children:nodes
              });
            }
          });
        }
        traverse(data, '');
        return pageTabs;
      }
      return getPageTabs(this.userRoute)
    },
  },
  methods:{
    itemClick(item){
      // 判断路由是否相同
      const path = this.$route.path
      if(path == item.path)return
      // 多级菜单
      if(item.children && item.children.length){
        const paths = item.children.map(route=>route.jumpUrl)
        if(!paths.includes(path)){
          this.$emit('itemClick',item.children)
        }
      }
      this.$router.push(item.path)
    },
    inputChange(){
      if(this.searchValue){
        this.result = this.getRouteList.filter(item=>item.label.indexOf(this.searchValue) != -1).map(item=>{
          const regex = new RegExp(this.searchValue, 'g');
          const str = item.label.replace(regex, function(match) {
            return `<span class="active">${match}</span>`;
          });
          return {
            label:str,
            path:item.path,
            children:item.children
          }
        })
        this.visible = true
      }else{
        this.result = []
        this.visible = false
      }
    },
    inputBlur(){
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
.search-popover{
  margin-top: 4px!important;
  border-radius: 8px;
  padding: 10px 8px 10px 18px !important;
  .active{
    color: #333;
    font-weight: bold;
  }
}
</style>

<style lang="scss" scoped>
.search{
  display: inline-block;
  // padding-left: 18px;
  @media screen and (max-width: 1459px) {
    padding-left: 38px;
  }
  @media screen and (max-width: 1440px) {
    padding-left: 0px;
  }
  &-input{
    width: 324px;
    @media screen and (max-width: 1700px) {
      width: 120px;
    }
  }
  &-list{
    max-height: 300px;
    &__scroll{
      height: 100%;
    }
    &-item{
      margin-bottom: 14px;
      padding-right: 10px;
      cursor: pointer;
      letter-spacing: 0.9px;
    }
  }
}
.el-icon-search{
  font-size: 18px;
}
::v-deep{
  .el-input__inner{
    border: none;
    border-radius: 16px;
    padding-left: 32px;
  }
  .el-scrollbar__thumb{
    width:3px!important;
  }
  .el-scrollbar__wrap{
    overflow-x:hidden;
  }
  .el-scrollbar__bar.is-horizontal{
    display: none!important;
  }
}

.findInput {
  display: flex;
  height: 28px;
  width: 250px;
  // padding: 7px;
  border-radius: 6px;
  align-items: center;
  background: #ffffff;
  overflow: hidden;
  ::v-deep .el-input__inner {
    border-width: 0px !important;
  }
}

</style>